import {
  BarChart3,
  LineChart,
  BarChart,
  PieChart,
  Table2,
  GitBranch,
  Radar,
  Grid3X3,
  ScatterChart,
  AreaChart,
  Columns,
  Network,
  Filter,
  Gauge,
} from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

/**
 * Map capitalized ComponentNode.type strings to lucide icons. Keyed by the
 * same string values stored in `surfaces.components[].type` JSONB and surfaced
 * via `WorkspaceListItem.vizTypes` — see supabase-adapter.ts. Non-viz types
 * (Row, Column, Text, etc.) fall through to BarChart3 by design; the minimap
 * only highlights visualization-shaped components.
 */
const VIZ_ICON_MAP: Record<string, LucideIcon> = {
  LineChart: LineChart,
  BarChart: BarChart,
  AreaChart: AreaChart,
  PieChart: PieChart,
  ScatterPlot: ScatterChart,
  Heatmap: Grid3X3,
  Histogram: BarChart3,
  RadarChart: Radar,
  SankeyChart: Network,
  FunnelChart: Filter,
  GaugeChart: Gauge,
  DataTable: Table2,
  Kanban: Columns,
  Mermaid: GitBranch,
};

/** Get icon for a known component-node type. Unknown types fall back to BarChart3. */
export function getVizIcon(type: string): LucideIcon {
  return VIZ_ICON_MAP[type] ?? BarChart3;
}

/** Get icon by fuzzy label matching (for canvas viz-ref nodes that carry display labels). */
export function getVizIconByLabel(label: string): LucideIcon {
  const lower = label.toLowerCase();
  if (lower.includes('line')) return LineChart;
  if (lower.includes('bar')) return BarChart;
  if (lower.includes('pie')) return PieChart;
  if (lower.includes('table')) return Table2;
  if (lower.includes('mermaid')) return GitBranch;
  if (lower.includes('radar')) return Radar;
  if (lower.includes('heatmap')) return Grid3X3;
  if (lower.includes('scatter')) return ScatterChart;
  if (lower.includes('histogram')) return BarChart3;
  if (lower.includes('area')) return AreaChart;
  if (lower.includes('kanban')) return Columns;
  if (lower.includes('sankey')) return Network;
  if (lower.includes('funnel')) return Filter;
  if (lower.includes('gauge')) return Gauge;
  return BarChart3;
}
